import { DiffLine, type DiffLineProps } from 'components/Diff/DiffLine';
import { getChangeStatus } from 'components/Diff/helpers/getChangeStatus';
import { getLinesFromChange } from 'components/Diff/helpers/getLinesFromChange';
import type { Change } from 'diff';
import { array } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import type { ReactNode } from 'react';

const changesToDiffLinesProps = (changes: Change[]) => {
  let oldLineNumber = 1;
  let newLineNumber = 1;

  const diffLinesProps: DiffLineProps[] = [];

  const expandChangeToLines = (change: Change): void => {
    for (const line of getLinesFromChange(change)) {
      diffLinesProps.push({
        content: line,
        status: getChangeStatus(change),
        lineNumber: change.added ? undefined : oldLineNumber,
        newLineNumber: change.removed ? undefined : newLineNumber,
        inline: true,
      });
      if (!change.added) {
        oldLineNumber += 1;
      }
      if (!change.removed) {
        newLineNumber += 1;
      }
    }
  };

  changes.forEach(expandChangeToLines);
  return diffLinesProps;
};

export const renderInlineChanges = (changes: Change[]): ReactNode =>
  pipe(
    changes,
    changesToDiffLinesProps,
    array.mapWithIndex((index, diffLineProps) => (
      <DiffLine key={index} {...diffLineProps} />
    )),
  );
